/* RESPONSIBLE TEAM: team-proactive-support */
interface NodeSettings {
  defaultWidth: number;
  defaultHeight: number;
  defaultSpacing: number;
  minHorizontalSpacing: number;
  minVerticalSpacing: number;
}

interface OptionalNodeSettings {
  defaultWidth?: number;
  defaultHeight?: number;
  defaultSpacing?: number;
  minHorizontalSpacing?: number;
  minVerticalSpacing?: number;
}

const DEFAULT_NODE_SETTINGS: NodeSettings = {
  defaultWidth: 200,
  defaultHeight: 150,
  defaultSpacing: 200,
  minHorizontalSpacing: 100,
  minVerticalSpacing: 50,
};

export { NodeSettings, OptionalNodeSettings, DEFAULT_NODE_SETTINGS };
